customElements.get("product-gallery") ||
  customElements.define(
    "product-gallery",
    class extends HTMLElement {
      connectedCallback() {
        console.log("product-gallery connected");
        this.selectors = {
          mainSwiper: ".product-swiper",
          thumbsSwiper: ".thumbs-swiper",
          prevButton: ".swiper-button-prev",
          nextButton: ".swiper-button-next",
          pagination: ".swiper-pagination",
          countCurrent: ".swiper-count-current",
          countTotal: ".swiper-count-total",
        };

        const mainNode = this.querySelector(this.selectors.mainSwiper);
        const thumbsNode = this.querySelector(this.selectors.thumbsSwiper);
        const prevButton = this.querySelector(this.selectors.prevButton);
        const nextButton = this.querySelector(this.selectors.nextButton);
        const paginationNode = this.querySelector(this.selectors.pagination);
        const countCurrent = this.querySelector(this.selectors.countCurrent);
        const countTotal = this.querySelector(this.selectors.countTotal);

        const thumbsSwiper = new Swiper(thumbsNode, {
          spaceBetween: 8,
          slidesPerView: 8,
          watchSlidesProgress: true,
          a11y: false,
          on: {
            init() {
              thumbsNode.classList.add('is-ready');
            }
          }
        });
        const mainSwiper = new Swiper(mainNode, {
          a11y: false,
          // effect: "fade",
          fadeEffect: {
            crossFade: true,
          },
          spaceBetween: 8,
          slidesPerView: 1,
          breakpoints: {
            750: {
              slidesPerView: 2,
            },
          },
          thumbs: {
            swiper: thumbsSwiper,
          },
          ...(paginationNode && {
            pagination: {
              el: paginationNode,
              clickable: true,
            },
          }),
          ...(prevButton && nextButton && {
            navigation: {
              prevEl: prevButton,
              nextEl: nextButton,
            },
          }),
        });

        if (countCurrent && countTotal) {
          mainSwiper.on("slideChange", () => {
            countCurrent.textContent = mainSwiper.realIndex + 1;
          });
          mainSwiper.on("init", () => {
            countCurrent.textContent = mainSwiper.realIndex + 1;
          });
        }
      }
    }
  );